/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для кнопки инициализации модального окна в разделе контактов (/kontakty/managers/).
   */
  app.ManagerContactsPopupView = app.PopupView.extend({
    additionalOptions: ['countryFlag'],
    /**
     * @inheritDoc
     */
    run: function () {
      var that = this,
        opener = this.$el.data('open'),
        popup = $('[data-open-popup="' + opener + '"]');
      this.canClosePopup = true;

      this.initPopup(popup, this.$el);

      /**
       * Иногда не нужно закрывать окно popup при наступлении стандартных событий, например,
       * если в одном popup размещен другой элемент popup (форма задания вопроса в разделе контактов).
       */
      this.popup.addEventListener(
        als.Popup.EventType.AFTER_CLOSE,
        function () {
          if (!that.canClosePopup) {
            that.popup.open();
            that.canClosePopup = true;
          }
        }
      );

      this.listenTo(this.countryFlag, 'change', this.choiceCountry);
    },
    /**
     * Инициализирует попап
     * @param {jQuery} popup
     * @param {jQuery} opener
     * @param {Object} [css]
     */
    initPopup: function (popup, opener, css) {
      this.popup = new als.Popup(popup, opener);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var width = this.getPopupSize(),
            offsetLeft = this.$el.parent().offset().left - (width - this.$el.parent().width()) / 2,
            offsetTop = this.$el.offset().top + this.$el.innerHeight() + 10,
            body = $('body');
          if (app.isMobile) {
            offsetLeft = (body.width() - width) / 2;
            offsetTop = offsetTop - body.position().top;
          }
          css = {
            left: offsetLeft,
            top: offsetTop,
            width: width,
          };
          popup.css(css);
          if (opener.data('manager_id')) {
            $('#' + opener.data('open') + ' [name=manager_id]').val(opener.data('manager_id'));
          }
        }.bind(this)
      );
    },
    /**
     * Определение размеров для элемента.
     * @returns {Number}
     */
    getPopupSize: function () {
      var width = 320,
        minWidth = 230;

      if (this.$el.parent().width() < 320) {
        width = this.$el.parent().width() - minWidth >= 0
          ? this.$el.parent().width()
          : minWidth;
      }
      if (app.isMobile) {
        width = 296;
      }
      return width;
    },
    /**
     * При выборе пользователем страны устанавливаем флаг.
     */
    choiceCountry: function () {
      this.canClosePopup = false;
    },
  });
})(jQuery);

}.call(window));